import { useMutation } from "@tanstack/react-query";
import GeocodeService from "../../services/geocodeService";

export const useGeocode = (queryOptions = {}) => {
  return useMutation(
    ({
      address_line_1,
      address_line_2,
      postal_zip_code,
      city_name,
      state_province,
      country_name,
    }) =>
      GeocodeService.create({
        address_line_1,
        address_line_2,
        postal_zip_code,
        city_name,
        state_province,
        country_name,
      }),
    queryOptions
  );
};
